module.exports = __webpack_public_path__ + "img/pasture_panicum_high.e18d3146.webp";